import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useOrgCapabilities } from "@/features/settings/useOrgCapabilities";
import { useCurrentBook } from "../api";

/** Existing org-admin setup access plus the server's established read capability.
 * This grants no write permission: every write still uses assignment.can_write.
 * ProtectedRoute and FeatureAddonRoute remain outside this Books-only guard.
 */
export function BooksRoute({ children }: { children: ReactNode }) {
  const { isAdmin } = useOrgCapabilities();
  const { assignment, isLoading, error } = useCurrentBook();
  if (isLoading) return <div className="flex min-h-screen items-center justify-center bg-background"><p className="text-sm text-muted-foreground">Loading books…</p></div>;
  if (!isAdmin && (error || !assignment?.can_read)) return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
}
